import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  eventLayout: {
    backgroundColor: 'var(--background-default)',
    height: '100%',
    overflow: 'hidden',

    '&:not([scrolled])': {
      '& .eventInfoCardWrapper': {
        '&:after': {
          content: '""',
          animation: 'var(--fade-in)',
          background:
            'linear-gradient(0deg,var(--background-default), rgba(255, 255, 255, 0) 100%)',
          position: 'absolute',
          bottom: 0,
          left: 0,
          height: '25vh',
          width: '100%',
          transform: 'translateY(100%)',
          zIndex: 10,
        },
      },
    },

    '&[scrolled]': {
      '& .scrollArrow': {
        transform: 'translateY(160%)',

        '& .prefixIcon': {
          transform: 'rotate(180deg)',
        },
      },
    },

    '& .iconWrap svg': {
      cursor: 'pointer',
      minWidth: '22px',
      minHeight: '22px',
      marginRight: '0px',

      '&:hover': {
        color: 'inherit',
      },
    },

    '&.isTimeline': {
      '& > .eventLayoutContainer': {
        ...mixins.noScroll,
        scrollSnapType: 'y mandatory',
        overflowY: 'scroll',
      },
    },

    '& > .container': {
      height: 'calc(100vh - 40px)!important',

      '& > .containerContent': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',

        '@media screen and (min-width: 1441px) and (max-width: 1536px)': {
          maxWidth: '1100px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        height: 'calc(100vh - 48px)!important',
      },
    },

    '& .eventLayoutContainer': {
      position: 'relative',

      '& > .containerContent': {
        display: 'block!important',
        zIndex: 1,
      },
    },
  },

  iconWrap: {
    zIndex: 3,
    padding: '6px 0',

    '& > .contentArea': {
      minHeight: '36px',
    },
  },

  reloadButton: {
    margin: '0 12px!important',
  },

  downloadSpotifyButton: {
    margin: '0 8px',
  },
}));

export default useStyles;
